import React, { useEffect, createElement } from 'react';
export function Modulo2Page() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://player.vimeo.com/api/player.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] text-[#e0e0e0] font-body" data-id="element-1159">
      {/* TOP NAV */}
      <nav className="sticky top-0 z-[100] flex h-[56px] items-center justify-between border-b border-[#1a1a1a] bg-black px-4 md:px-10" data-id="element-1160">
        <div className="font-heading text-[13px] font-black tracking-[3px] text-white uppercase" data-id="element-1161">
          AI <span className="text-[#F5C842]" data-id="element-1162">WEB CLOSER</span>
        </div>
        <div className="flex gap-1 overflow-x-auto" data-id="element-1163">
          <a href="/modulo-0" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1164">
            Módulo 0
          </a>
          <a href="/modulo-1" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1165">
            Módulo 1
          </a>
          <a href="/modulo-2" className="rounded bg-[#F5C842] px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-black transition-all" data-id="element-1166">
            Módulo 2
          </a>
          <a href="/modulo-3" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1167">
            Módulo 3
          </a>
          <a href="/modulo-4" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1168">
            Módulo 4
          </a>
          <a href="/calculadora" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#F5C842] transition-all hover:bg-[#1a1a1a] border border-[#F5C842]/30" data-id="element-1169">
            Calculadora
          </a>
        </div>
      </nav>

      {/* HERO */}
      <div className="border-b-[3px] border-[#F5C842] bg-gradient-to-br from-black to-[#0d0d0d] px-6 py-10 md:px-20 md:py-[60px] pb-[50px]" data-id="element-1170">
        <div className="mb-5 flex items-center gap-2.5" data-id="element-1171">
          <div className="rounded-sm bg-[#F5C842] px-3.5 py-1 font-heading text-[9px] font-black tracking-[3px] text-black uppercase" data-id="element-1172">
            Módulo 2 de 4
          </div>
          <div className="text-[11px] tracking-[2px] text-[#444] uppercase" data-id="element-1173">
            ⏱ 20 minutos · Herramienta: Ai Website Arbitrage
          </div>
        </div>
        <div className="mb-4 font-heading text-4xl md:text-[48px] font-black leading-[1.05] text-white" data-id="element-1174">
          El Cerebro
          <br data-id="element-1175" />
          <span className="text-[#F5C842]" data-id="element-1176">Cazador</span>
        </div>
        <div className="mb-8 max-w-[600px] text-[15px] leading-[1.7] text-[#888]" data-id="element-1177">
          Cómo usar el cerebro de IA "Ai Website Arbitrage" para encontrar 10
          prospectos perfectos en menos de 15 minutos — sin buscar manualmente.
        </div>
        <div className="flex flex-col md:flex-row gap-4 md:gap-6" data-id="element-1178">
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1179">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1180"></div>
            Herramienta: Ai Website Arbitrage en HEYLLOYD
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1181">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1182"></div>4
            filtros del prospecto ideal
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1183">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1184"></div>
            Lista de 5 prospectos listos para contactar
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div className="mx-auto max-w-[1100px] px-4 py-10 md:px-10 md:py-[50px]" data-id="element-1185">
        {/* VIDEO */}
        <div className="mb-10" data-id="element-1186">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1187">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1188"></span>
            Video del Módulo
          </div>
          <div className="overflow-hidden rounded-[10px] border-2 border-[#1e1e1e]" data-id="element-1189">
            <div style={{
            padding: '56.25% 0 0 0',
            position: 'relative'
          }} data-id="element-1190">
              <iframe src="https://player.vimeo.com/video/1179701651?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" allowFullScreen referrerPolicy="strict-origin-when-cross-origin" style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }} title="AI WEB CLOSER Video 2" data-id="element-1191" />
            </div>
          </div>
        </div>

        {/* BUTTON MODULO 2 */}
        <div className="mt-4 mb-10" data-id="element-1192">
          <a href="https://app.heylloyd.io/share/lloyd/d98723a5-a08" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-3 w-full rounded-lg border-2 border-[#F5C842] bg-[#F5C842] px-8 py-[18px] font-heading text-[14px] font-black tracking-[1.5px] text-black uppercase no-underline transition-opacity hover:opacity-85" style={{
          boxShadow: '0 4px 20px rgba(245,200,66,0.25)'
        }} data-id="element-1193">
            <span className="text-[20px]" data-id="element-1194">🧠</span>
            Abrir Ai Website Arbitrage en Heylloyd
            <span className="text-[18px] font-black" data-id="element-1195">→</span>
          </a>
        </div>

        {/* TOOL HIGHLIGHT */}
        <div className="mb-8 flex flex-col md:flex-row gap-6 items-start rounded-lg border border-[#2a2a2a] border-t-[3px] border-t-[#F5C842] bg-black p-7" data-id="element-1196">
          <div className="text-[48px] leading-none shrink-0" data-id="element-1197">🧠</div>
          <div data-id="element-1198">
            <div className="mb-1.5 text-[8px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1199">
              Heylloyd — Cerebro de IA
            </div>
            <div className="mb-2 font-heading text-[24px] font-black text-white" data-id="element-1200">
              Ai Website Arbitrage
            </div>
            <div className="max-w-[700px] text-[13px] leading-[1.7] text-[#888]" data-id="element-1201">
              La IA personalizada que escanea el mercado local y te entrega una
              lista de negocios sin sitio web o con sitios obsoletos. Solo le
              dices el tipo de negocio y la ciudad — ella hace todo el trabajo
              de investigación en segundos.
            </div>
          </div>
        </div>

        {/* HOW TO USE STEPS */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1202">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1203"></span>
          Cómo Usar Ai Website Arbitrage
        </div>
        <div className="mb-8 grid grid-cols-2 gap-3.5 md:grid-cols-4" data-id="element-1204">
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] p-[18px] text-center" data-id="element-1205">
            <div className="mx-auto mb-3 flex h-9 w-9 items-center justify-center rounded-full bg-[#F5C842] font-heading text-[14px] font-black text-black" data-id="element-1206">
              1
            </div>
            <div className="mb-1 text-[11px] font-bold text-white" data-id="element-1207">
              Abre HEYLLOYD
            </div>
            <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-1208">
              Accede a tu cuenta y selecciona el cerebro "Ai Website Arbitrage"
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] p-[18px] text-center" data-id="element-1209">
            <div className="mx-auto mb-3 flex h-9 w-9 items-center justify-center rounded-full bg-[#F5C842] font-heading text-[14px] font-black text-black" data-id="element-1210">
              2
            </div>
            <div className="mb-1 text-[11px] font-bold text-white" data-id="element-1211">
              Ingresa el nicho
            </div>
            <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-1212">
              Escribe el tipo de negocio (ej: "peluquerías", "restaurantes",
              "talleres")
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] p-[18px] text-center" data-id="element-1213">
            <div className="mx-auto mb-3 flex h-9 w-9 items-center justify-center rounded-full bg-[#F5C842] font-heading text-[14px] font-black text-black" data-id="element-1214">
              3
            </div>
            <div className="mb-1 text-[11px] font-bold text-white" data-id="element-1215">
              Ingresa la ciudad
            </div>
            <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-1216">
              Escribe tu ciudad o la ciudad donde quieres conseguir clientes
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] p-[18px] text-center" data-id="element-1217">
            <div className="mx-auto mb-3 flex h-9 w-9 items-center justify-center rounded-full bg-[#F5C842] font-heading text-[14px] font-black text-black" data-id="element-1218">
              4
            </div>
            <div className="mb-1 text-[11px] font-bold text-white" data-id="element-1219">
              Analiza los resultados
            </div>
            <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-1220">
              La IA te entrega nombre, teléfono y estado del sitio web de cada
              negocio
            </div>
          </div>
        </div>

        {/* FILTERS */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1221">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1222"></span>
          Los 4 Filtros del Prospecto Ideal
        </div>
        <div className="mb-8 grid grid-cols-1 gap-3 md:grid-cols-2" data-id="element-1223">
          <div className="flex items-start gap-3 rounded-lg border border-[#1e1e1e] bg-[#111] p-4" data-id="element-1224">
            <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded bg-[#F5C842] text-[11px] font-black text-black" data-id="element-1225">
              ✓
            </div>
            <div data-id="element-1226">
              <div className="mb-1 text-[12px] font-bold text-white" data-id="element-1227">
                Sin sitio web
              </div>
              <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-1228">
                La señal más clara de oportunidad. Si no tienen sitio, ya saben
                que lo necesitan — solo falta que alguien se los ofrezca.
              </div>
            </div>
          </div>
          <div className="flex items-start gap-3 rounded-lg border border-[#1e1e1e] bg-[#111] p-4" data-id="element-1229">
            <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded bg-[#F5C842] text-[11px] font-black text-black" data-id="element-1230">
              ✓
            </div>
            <div data-id="element-1231">
              <div className="mb-1 text-[12px] font-bold text-white" data-id="element-1232">
                Sitio con más de 3 años
              </div>
              <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-1233">
                Un sitio viejo es casi tan malo como no tener. El dueño sabe que
                está desactualizado y está abierto a mejorarlo.
              </div>
            </div>
          </div>
          <div className="flex items-start gap-3 rounded-lg border border-[#1e1e1e] bg-[#111] p-4" data-id="element-1234">
            <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded bg-[#F5C842] text-[11px] font-black text-black" data-id="element-1235">
              ✓
            </div>
            <div data-id="element-1236">
              <div className="mb-1 text-[12px] font-bold text-white" data-id="element-1237">
                Buenas reseñas en Google
              </div>
              <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-1238">
                Significa que ya tienen clientes reales y están activos. Un
                sitio web para ellos es una inversión, no un gasto.
              </div>
            </div>
          </div>
          <div className="flex items-start gap-3 rounded-lg border border-[#1e1e1e] bg-[#111] p-4" data-id="element-1239">
            <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded bg-[#F5C842] text-[11px] font-black text-black" data-id="element-1240">
              ✓
            </div>
            <div data-id="element-1241">
              <div className="mb-1 text-[12px] font-bold text-white" data-id="element-1242">
                Negocio físico con dirección
              </div>
              <div className="text-[11px] leading-[1.4] text-[#666]" data-id="element-1243">
                Negocios físicos tienen más urgencia de aparecer en búsquedas
                locales de Google que negocios 100% online.
              </div>
            </div>
          </div>
        </div>

        {/* WHAT TO SAVE */}
        <div className="mb-8 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-1244">
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1245">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1246">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1247"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1248">
                Datos que debes guardar de cada prospecto
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1249">
              <ul className="flex flex-col" data-id="element-1250">
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1251">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1252">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1253">Nombre del negocio</strong>
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1254">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1255">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1256">Nombre del dueño</strong> (si
                  aparece en Google)
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1257">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1258">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1259">Teléfono / WhatsApp</strong>
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1260">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1261">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1262">Estado del sitio</strong> — sin
                  sitio o sitio viejo
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1263">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1264">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1265">Número de reseñas</strong> en
                  Google
                </li>
                <li className="flex items-start gap-2 py-1" data-id="element-1266">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1267">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1268">Por qué lo elegiste</strong> —
                  tu razón de contacto
                </li>
              </ul>
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1269">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1270">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1271"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1272">
                Por qué las buenas reseñas son clave
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1273">
              Un negocio con buenas reseñas ya tiene clientes. Ya están ganando
              dinero. Un sitio web para ellos{' '}
              <strong className="text-white" data-id="element-1274">
                no es un gasto, es una inversión
              </strong>{' '}
              que les va a traer más clientes.
              <br data-id="element-1275" />
              <br data-id="element-1276" />
              Eso hace que la conversación de venta sea completamente diferente.
              No estás convenciéndolos de gastar — estás mostrándoles cómo{' '}
              <strong className="text-white" data-id="element-1277">ganar más</strong>.
            </div>
          </div>
        </div>

        {/* SCRIPT */}
        <div className="mb-8" data-id="element-1278">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1279">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1280"></span>
            Guion Completo del Módulo
          </div>

          <div className="mb-4" data-id="element-1281">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1282">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1283"></span>⏱
              0:00 – 0:30 · Introducción
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1284">
              "Bienvenido al Módulo 2. Aquí es donde la magia empieza. Voy a
              mostrarte cómo usar el cerebro de IA{' '}
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-1285">
                'Ai Website Arbitrage'
              </span>{' '}
              para encontrar 10 prospectos perfectos en menos de 15 minutos.
              Abre el software y sígueme."
            </div>
          </div>

          <div className="mb-4" data-id="element-1286">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1287">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1288"></span>⏱
              0:30 – 15:00 · Demo en Pantalla
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1289">
              "Primero, abre el cerebro{' '}
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-1290">
                'Ai Website Arbitrage'
              </span>{' '}
              en HEYLLOYD. Vas a ver una pantalla que te pide dos cosas: el tipo
              de negocio y la ciudad. Escribe, por ejemplo,{' '}
              <span className="not-italic text-[#666]" data-id="element-1291">'peluquerías'</span> y{' '}
              <span className="not-italic text-[#666]" data-id="element-1292">'Miami'</span>. Ahora
              observa lo que hace."
              {'\n\n'}
              "El cerebro analiza los resultados de Google Maps y te da una
              lista de negocios con su nombre, dirección, teléfono y, lo más
              importante, si tienen sitio web o no. También te dice si el sitio
              que tienen es moderno o está desactualizado."
              {'\n\n'}
              "De esta lista, quiero que identifiques los 5 mejores prospectos.
              Los mejores son los que: no tienen sitio web, tienen un sitio con
              más de 3 años de antigüedad, tienen buenas reseñas en Google (lo
              que significa que tienen clientes reales y están activos), y son
              negocios físicos con una dirección real."
              {'\n\n'}
              "¿Por qué estos criterios? Porque un negocio con buenas reseñas ya
              tiene clientes. Ya están ganando dinero. Un sitio web para ellos
              no es un gasto, es una inversión que les va a traer más clientes.
              Eso hace que la venta sea mucho más fácil."
            </div>
          </div>

          <div className="mb-4" data-id="element-1293">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1294">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1295"></span>⏱
              15:00 – 20:00 · Cierre y Tarea
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1296">
              "Tu tarea: usa el cerebro{' '}
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-1297">
                'Ai Website Arbitrage'
              </span>{' '}
              y encuentra tus 5 mejores prospectos. Guarda su nombre, teléfono y
              por qué los elegiste. En el Módulo 3, vamos a construir una demo
              de su sitio web antes de hablar con ellos. Eso es lo que hace que
              esta venta sea diferente a cualquier otra."
            </div>
          </div>
        </div>

        {/* TASK */}
        <div className="mb-8 rounded-r-lg border border-[#1a3a1a] border-l-[4px] border-l-[#4caf50] bg-[#0a150a] px-[26px] py-[22px]" data-id="element-1298">
          <div className="mb-2.5 font-heading text-[9px] font-bold tracking-[2px] text-[#4caf50] uppercase" data-id="element-1299">
            ✅ Tu Tarea — Módulo 2
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1300">
            Usa <strong className="text-white" data-id="element-1301">Ai Website Arbitrage</strong> en
            HEYLLOYD y encuentra tus{' '}
            <strong className="text-white" data-id="element-1302">5 mejores prospectos</strong>. No
            pases al Módulo 3 sin completar esta tarea.
            <div className="mt-3 flex flex-col gap-2" data-id="element-1303">
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1304">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1305">
                  1
                </div>
                Abre HEYLLOYD y selecciona el cerebro "Ai Website Arbitrage"
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1306">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1307">
                  2
                </div>
                Ingresa el tipo de negocio y tu ciudad
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1308">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1309">
                  3
                </div>
                Aplica los 4 filtros del prospecto ideal para seleccionar los
                mejores
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1310">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1311">
                  4
                </div>
                Guarda nombre, teléfono y razón de selección de cada uno
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1312">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1313">
                  5
                </div>
                <strong className="text-white" data-id="element-1314">
                  Selecciona tus 5 mejores prospectos y pasa al Módulo 3
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER NAV */}
      <div className="mt-5 flex items-center justify-between border-t border-[#1a1a1a] bg-black px-4 py-6 md:px-10" data-id="element-1315">
        <a href="/modulo-1" className="flex items-center gap-1.5 text-[12px] font-bold text-[#555] no-underline transition-colors hover:text-white" data-id="element-1316">
          ← Módulo 1
        </a>
        <div className="font-heading text-[11px] font-black tracking-[3px] text-[#333] uppercase" data-id="element-1317">
          AI <span className="text-[#F5C842]" data-id="element-1318">WEB CLOSER</span>
        </div>
        <a href="/modulo-3" className="flex items-center gap-2 rounded bg-[#F5C842] px-7 py-3 font-heading text-[12px] font-black tracking-[1px] text-black uppercase transition-opacity hover:opacity-85" data-id="element-1319">
          Módulo 3: La Demo que Cierra Sola →
        </a>
      </div>
    </div>;
}